(function () {
    if (!document.body.classList.contains('best-pages-top-3-cards-experiment')) {
        return;
    }

    function syncPromotionCtaFromButtonCta() {
        document.querySelectorAll('.promotion-container.active').forEach(function (container) {
            var buttonCta = container.closest('.button-cta');
            if (!buttonCta) return;

            var title = buttonCta.getAttribute('data-cta-title');
            var subtext = buttonCta.getAttribute('data-cta-subtext');
            if (!title) return;

            var link = container.querySelector('.ps-cta-container > a');
            if (!link) return;

            var icon = link.querySelector('i.chevron-right, i');
            link.textContent = '';
            link.appendChild(document.createTextNode(title));
            if (subtext) {
                var span = document.createElement('span');
                span.textContent = subtext;
                link.appendChild(span);
            }
            if (icon) {
                link.appendChild(icon);
            }
        });
    }

    if (document.body.classList.contains('best-pages-top-3-cards-variant-2')) {
        var bodyObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    mutation.target.classList.contains('active-scheduled-promotion')) {
                    syncPromotionCtaFromButtonCta();
                }
            });
        });
        bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    var mobileMQ = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 768px)') : null;

    function getSeeMoreLabel(btn) {
        if (!btn || typeof btn.getAttribute !== 'function') return 'See more';
        try {
            var isExpanded = btn.getAttribute('aria-expanded') === 'true';
            if (mobileMQ && mobileMQ.matches) {
                var bottomLine = btn.closest && btn.closest('.best-pages-top-3-experiment__bottom-line');
                var titleEl = bottomLine && bottomLine.querySelector && bottomLine.querySelector('.best-pages-top-3-experiment__bottom-line-title');
                if (titleEl && titleEl.textContent != null) {
                    var text = String(titleEl.textContent).trim();
                    if (text) return text.replace(/^\s*:\s*/, '');
                }
                return isExpanded ? 'See less' : 'See more';
            }
            return isExpanded ? 'See less' : 'See more';
        } catch (err) {
            return 'See more';
        }
    }

    function updateSeeMoreText(btn) {
        if (!btn || typeof btn.querySelector !== 'function') return;
        try {
            var textSpan = btn.querySelector('.best-pages-top-3-experiment__see-more-text');
            if (textSpan) textSpan.textContent = getSeeMoreLabel(btn);
        } catch (err) {
            // our label logic must not break the page
        }
    }

    document.querySelectorAll('.best-pages-top-3-experiment .js-see-more').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            var targetId = this.getAttribute('data-target');
            var target = targetId ? document.getElementById(targetId) : null;
            if (!target) return;

            e.preventDefault();
            var isExpanded = this.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                target.setAttribute('hidden', '');
                this.setAttribute('aria-expanded', 'false');
                this.classList.remove('is-expanded');
            } else {
                target.removeAttribute('hidden');
                this.setAttribute('aria-expanded', 'true');
                this.classList.add('is-expanded');
            }
            updateSeeMoreText(this);
        });
    });

    if (mobileMQ && typeof mobileMQ.addEventListener === 'function') {
        mobileMQ.addEventListener('change', function () {
            try {
                document.querySelectorAll('.best-pages-top-3-experiment .js-see-more').forEach(updateSeeMoreText);
            } catch (err) {
                // our label update must not break on resize
            }
        });
    }

    document.querySelectorAll('.best-pages-top-3-experiment .js-see-more').forEach(updateSeeMoreText);

    document.querySelectorAll('.best-pages-top-3-experiment-header-subtitle-mobile-wrapper__see-more-text').forEach(function (textEl) {
        var btn = textEl.closest('.js-see-more');
        if (!btn) return;
        var wrapper = btn.closest('.best-pages-top-3-experiment-header-subtitle-mobile-wrapper');
        if (!wrapper) return;

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var isExpanded = this.getAttribute('aria-expanded') === 'true';
            wrapper.classList.toggle('hidden', isExpanded);
            this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
            textEl.textContent = isExpanded ? 'See more' : 'See less';
        });
    });
})();
